import { render, staticRenderFns } from "./OrderGroup.vue?vue&type=template&id=3d18a60b&scoped=true"
import script from "./OrderGroup.vue?vue&type=script&lang=js"
export * from "./OrderGroup.vue?vue&type=script&lang=js"
import style0 from "./OrderGroup.vue?vue&type=style&index=0&id=3d18a60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18a60b",
  null
  
)

export default component.exports